<template>
    <modal :title="title" :show.sync="show" :close-show="true" :footerBtnShow=false>
        <div slot="content">
            <div class="info" v-html=message></div>
        </div>
    </modal>
</template>

<script type="text/javascript">
export default {
    name: 'message',
    props: {
        // title: {
        //     type: String,
        //     default: '信息'
        // },
        // message: {
        //     type: String,
        //     default: '信息信息信息信息'
        // },
        // show: {
        //     type: Boolean,
        //     default: false
        // },
        // closeShow: {
        //     type: Boolean,
        //     default: true
        // }
    },
    data() {
        return {
            show:true,
            closeShow:true
        }
    },
    methods: {
        close() {
            this.show = false
            this.$emit('update:show', false)
        }
    }
}
</script>

<style lang="scss">
.modal {
    .content {
        min-height: 83px;
    }
    .info{
        padding-top: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/message.vue